<template>
  <v-container>
    <v-tabs>
      <v-tab>USER PROFILE</v-tab>

      <v-tab-item>
        <UserSettings />
      </v-tab-item>

      <v-tab-item>
        <WorkstationSetting />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import UserSettings from './UserSettings.vue';

export default {
  name: 'ProfileSettings',
  components: {
    UserSettings,
  },
};
</script>
